import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import { useThemeEffect } from '../../hooks/useThemeEffect';
import Sidebar from '../sidebar';
import Header from '../header/Header';
import './AdminLayout.scss';

const AdminLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  
  // Apply theme effects
  useThemeEffect();

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="admin-layout">
      <Sidebar
        collapsed={sidebarCollapsed} 
        onToggle={toggleSidebar}
      />
      
      <div className={`main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Header onToggleSidebar={toggleSidebar} />
        
        <main className="content-area">
          <Container fluid>
            {children}
          </Container>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;

